<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">{{data ? 'Edit User Settings': 'Add A User'}}</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="close()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">{{data ? "Edit " + data.name + "'s access settings": 'Add a new user to this account'}}</div>
        </div>
    </div>
</div>

<div class="modal-body custom-material-form" [formGroup]="form">
    <div class="row">
        <div class="col-6" style="border-right: 1px solid lightgrey;">
            <mdb-form-control class="form-fill">
                <app-mdbp-input mdbInput formControlName="name" label='User Name'></app-mdbp-input>
                <mdb-error class="form-fill-error"  *ngIf="form.controls.name.hasError('required') && form.controls.name.touched ">Please provide User Name</mdb-error>
            </mdb-form-control>
        
            @if(!data) {
                <mdb-form-control class="form-fill">
                    <app-mdbp-input mdbInput formControlName="email" label='User Email'></app-mdbp-input>
                    <mdb-error class="form-fill-error"  *ngIf="form.controls.email.hasError('required') && form.controls.email.touched ">Please provide User Email</mdb-error>
                    <mdb-error class="form-fill-error"  *ngIf="form.controls.email.hasError('pattern') && form.controls.email.touched ">Invalid User Email</mdb-error>
                </mdb-form-control>
            }

            <div class="px-3 py-1 mb-3" style="background: lightgrey;">
                <div class="body-1--weight-bold mb-1">Select Role(s)</div>
                <div class="body-2">Choose a role for this user from one or more of the options below</div>
            </div>
            
            <div class="form-group d-flex justify-content-start">
                <div class="form-check form-checkbox">
                    <input
                      mdbCheckbox
                      class="form-check-input form-checkbox-input--inline"
                      type="checkbox"
                      id="fullAdmin"
                      formControlName="fullAdmin"
                    />
                    <label class="form-check-label form-checkbox-label" for="fullAdmin">
                        Account Admin
                    </label>
                  </div>
            </div>

            <div class="form-group d-flex justify-content-start">
                <div class="form-check form-checkbox">
                    <input
                      mdbCheckbox
                      class="form-check-input form-checkbox-input--inline"
                      type="checkbox"
                      id="campaignManager"
                      formControlName="campaignManager"
                    />
                    <label class="form-check-label form-checkbox-label" for="campaignManager">
                        Campaign Manager
                    </label>
                  </div>
            </div>

            <ng-container *ngIf="hasCampaignManager">
                <ng-container *ngIf="campaigns$ | async as campaigns">
                    <div style="margin-left:59px">
                        <mdb-form-control class="form-fill w-100 mb-4">
                            <mdb-select formControlName="campaigns" class="mdb-select" [filter]="true" [multiple]="true">
                              <mdb-option class="option--multiple" value="all">Select All</mdb-option>
                              <mdb-option class="option--multiple" *ngFor="let campaign of campaigns" [value]="campaign.id">{{
                                campaign.name
                              }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                        </mdb-form-control>
                    </div>
                </ng-container>
            </ng-container>

            <div class="form-group d-flex justify-content-start">
                <div class="form-check form-checkbox">
                    <input
                      mdbCheckbox
                      class="form-check-input form-checkbox-input--inline"
                      type="checkbox"
                      id="eventManager"
                      formControlName="eventManager"
                    />
                    <label class="form-check-label form-checkbox-label" for="eventManager">
                        Event Manager
                    </label>
                  </div>
            </div>

            <div class="form-group d-flex justify-content-start">
                <div class="form-check form-checkbox">
                    <input
                      mdbCheckbox
                      class="form-check-input form-checkbox-input--inline"
                      type="checkbox"
                      id="finance"
                      formControlName="finance"
                    />
                    <label class="form-check-label form-checkbox-label" for="finance">
                        Finance
                    </label>
                  </div>
            </div>
        </div>
        <div class="col-6">
            <ng-container *ngIf="isSelected()">
                <ng-container *ngFor="let role of list">
                    <div class="mb-3" *ngIf="role.value">
                        <div class="body-1--weight-bold">{{role.label}}</div>
                        <div class="body-2">{{role.description}}</div>
                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!isSelected()">
                <div class="mb-3 body-2">Choose a role from one or more of the options below:</div>
                <div class="mb-3">
                    <div class="body-1--weight-bold">Account Admin</div>
                    <div class="body-2">An account admin can access everything on this account, including all campaigns, events, and reports. They can also add other account admins to this account.</div>
                </div>
                <div class="mb-3">
                    <div class="body-1--weight-bold">Campaign Manager</div>
                    <div class="body-2">A campaign manager can edit selected campaigns on this account. They can also access the All Donations report and Campaigns report but will only see transactions associated with the selected campaigns.</div>
                </div>
                <div class="mb-3">
                    <div class="body-1--weight-bold">Event Manager</div>
                    <div class="body-2">An event manager can create a new event, edit and manage existing events, and access all pending carts. They can add pledges, check out carts, check guests in, send out event invitations, event reminders, add guest reminders and pending cart reminders within the event.</div>
                </div>
                <div class="mb-3">
                    <div class="body-1--weight-bold">Finance Manager</div>
                    <div class="body-2">A finance manager can access all reports but cannot edit or create new campaigns or events.</div>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<div class="modal-footer paybee-modal-footer">
    <a class="btn btn-sm modal-cancel-button waves-effect waves-light" (click)="close()">Cancel</a>
    <a class="btn btn-sm modal-confirm-button waves-effect waves-light" (click)="submit()">{{data ? 'Save': 'Add'}}</a>
</div>